const HomepageSchema = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'MyMathsCloud',
  url: 'https://www.mymathscloud.com/',
  logo: 'https://www.datocms-assets.com/34817/1600883466-logo-small.svg',
};

const QuestionBankSchema = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'MyMathsCloud',
  url: 'https://www.mymathscloud.com/',
  logo: 'https://www.datocms-assets.com/34817/1600883466-logo-small.svg',
};

export { HomepageSchema, QuestionBankSchema };
